import React, { useEffect, useState, useRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import RateCard from "../../../../../Util/RateCard/RateCard";
import "react-datepicker/dist/react-datepicker.css";
import "./AddTicket.css";
import "../../Users/User/User.css";
import { config } from "../../../../../config";
import { formatNumberToCurrency, maskingToPlainNumber, PAYMENT_MODE, PAYMENT_STATUS } from "../../../../../Util/helper";
import axiosApi from "../../../../../core/interceptor/interceptor";
import add from "../../../../../assets/add-icon.svg";
import print from "../../../../../assets/print-icon.svg";
import closeIcn from "../../../../../assets/cross.svg";
import checkIcn from "../../../../../assets/check-icon.svg";

import AddTicket from "./AddTicket";
import { useReactToPrint } from 'react-to-print';
import TicketPrint from "../Ticketprint";
import RedundPopup from "../RedundPopup";
import WarningDialogue from '../../../../../Util/WarningDialogue';
import { messages } from "../../../../../messages";
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function EventTicket(props) {
  const [refundPopup, setRefundPopup] = useState(false);
  const [refundInfo, setRefundInfo] = useState({
    id: 0,
    total: 0
  });
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popUpContent, setPopUpContent] = useState({});
  const columns = [
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Booked By</div>,
      selector: () => 'booked_by',
      className: 'left-align',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.user && row.user.booked_by ? `${row.user.booked_by}` : row.booked_by ? row.booked_by : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Email</div>,
      selector: () => 'email',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.user && row.user.email ? `${row.user.email}` : row.email ? row.email : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Phone</div>,
      selector: () => 'cell_phone',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.user && row.user.cell_phone ? `${row.user.cell_phone}` : row.phone ? row.phone : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>No of Ticket</div>,
      selector: () => 'no_of_tickets',
      minWidth: '125px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.no_of_tickets ? row.no_of_tickets : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Total Price</div>,
      selector: () => 'total_price',
      minWidth: '125px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.total_price ? formatNumberToCurrency(row.total_price) : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Payment Status</div>,
      selector: () => 'payment_status',
      minWidth: '136px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.payment_status ? PAYMENT_STATUS[row.payment_status] : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Payment Mode</div>,
      selector: () => 'paid_by',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.paid_by ? PAYMENT_MODE[row.paid_by] : 'N/A'}</div>)
    },

    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Action</div>,
      selector: () => '',
      minWidth: '180px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>
        {
          row.status === 'active' && row.paid_by === 'card' && row.paid_type === 'paid' &&
          <>
            <button className="btn mb-0" onClick={() => refundAmount(row)}>Cancel All</button>
            <button className="btn mb-0 p-btn ml-10" onClick={() => openInvoice(row)}>
              <img src={print} title="Scan Ticket" />
            </button>
          </>
        }
        {
          row.status === 'active' && (row.paid_by !== 'card' || row.paid_type === 'free') &&
          <>
            <button className="btn mb-0" onClick={() => cancelAll(row)}>Cancel All</button>
            <button className="btn mb-0 p-btn ml-10" onClick={() => openInvoice(row)}>
              <img src={print} title="Scan Ticket" />
            </button>
          </>
        }
        {row.status === 'cancel' && 'Cancel'}

      </div>)
    },
  ];

  if (props.scanTicket) {
    columns.splice(7, 0, {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Visited</div>,
      selector: () => 'scanned',
      minWidth: '136px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.scanned ? <img src={checkIcn} className="ticket-vist-img" /> : <img src={closeIcn} className="ticket-vist-img" />}</div>)
    });

    columns.pop();
  }
  const printColumns = [
    {
      name: 'Ticket No',
    },
    {
      name: 'Name',
    },
    {
      name: 'Email'
    },
    {
      name: 'Phone',
    },
    {
      name: 'Total Price',
    },
    {
      name: 'Payment Status',
    },
    {
      name: 'Payment Mode',
    },
  ];

  const printRow = [
    {
      field: 'ticket_no',
      type: 'number',
    },
    {
      field: 'first_name',
      secondary: 'last_name',
      type: 'full_name'
    },
    {
      field: 'email',
    },
    {
      field: 'phone'
    },
    {
      field: 'total_price'
    },
    {
      field: 'payment_status'
    },
    {
      field: 'paid_by'
    },
  ];

  const history = useHistory();
  const [totalPage, setTotalPage] = useState(0);
  const [tickets, setTickets] = useState([]);
  const [allTickets, setAllTickets] = useState([]);
  const printRef = useRef();
  const [queryparam, setQueryparam] = useState({
    first_name: '',
    last_name: '',
    cell_phone: '',
    email: '',
    direction: 'desc',
    sort_column: 'id',
    page: 1,
    limit: 50,
  });
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState({
    open: false,
    data: ''
  });
  const [overview, setOverview] = useState({
    total: 0,
    sold: 0,
    left: 0
  });
  const [showHiddleDataTable, setShowHiddleDataTable] = useState(false);

  useEffect(() => {
    if (props.eventId) {
      getTickets(props.eventId, queryparam);
      getOverview(props.eventId);
    }
  }, [props.eventId])

  useEffect(() => {
    getTickets(props.eventId, queryparam);
    //eslint-disable-next-line
  }, [queryparam.page, queryparam.limit, queryparam.direction, queryparam.sort_column])

  useEffect(() => {
    setIsAdd(props.openCloseTicketInfo);
  }, [props.openCloseTicketInfo])

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.name === 'cell_phone' ? maskingToPlainNumber(e.target.value) : String(e.target.value).trim(),
      })
    }
    setQueryparam(stateFunc);
  }

  const getOverview = (id) => {
    axiosApi.get(`${config.apiUrl}/tickets/overview/${id}`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          const data = res.data.data;
          const leftTicket = +data?.no_of_guest - (+data?.event_tickets[0]?.sold || 0);
          setOverview({
            total: data && data?.no_of_guest,
            sold: data && data.event_tickets && data.event_tickets.length ? +data?.event_tickets[0]?.sold : 0,
            left: leftTicket,
            scanned: data?.event_ticket_transactions?.length > 0 ? +data?.event_ticket_transactions[0]?.total_scanned : 0
          })
        }
      })
  }

  const handleSearch = (e) => {
    e.preventDefault();
    setQueryparam(() => ({
      ...queryparam,
      'page': 1,
      'direction': 'desc',
      'sort_column': 'id',
    }));
    getTickets(props.eventId, queryparam);
  }

  const getTickets = (id, params) => {
    axiosApi.get(`${config.apiUrl}/tickets/${id}`, { params })
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.rows) {
          res?.data?.data?.rows.forEach(element => {
            element.defaultExpanded = true;
          });
          setTickets(res?.data?.data?.rows);
        }
      })
  }

  const showListing = () => {
    setIsAdd(false);
    props.isTicketInfo(false);
    setIsEdit({
      open: false,
      data: ''
    });
  }

  const refreshList = (cb) => {
    if (cb) {
      getTickets(props?.eventId, queryparam);
      getOverview(props?.eventId);
    }
  }

  const showTicket = (cb) => {
    if (!props.scanTicket) {
      setIsAdd(true);
      props.isTicketInfo(true);
      setIsEdit((prev) => ({
        ...prev,
        open: true,
        data: cb
      }));
    }
  }

  // Get all data for listing and call print method 
  const printAllData = () => {
    setShowHiddleDataTable(true);
    const params = queryparam;
    params.no_limit = true;

    axiosApi.get(`${config.apiUrl}/tickets/${props?.eventId}`, { params })
      .then((res) => {
        delete params.no_limit;
        setQueryparam(params);
        const response = res?.data?.data?.rows;
        const tempArr = [];
        response.forEach((element, i) => {
          if (element?.event_tickets?.length) {
            element.event_tickets.forEach((ticket, j) => {
              if (ticket !== 'cancel') {
                const price = +element.ticket_price + (element.stripe_fees ? +element.stripe_fees / element.no_of_tickets : 0);
                tempArr.push({
                  ...ticket,
                  payment_status: element.payment_status ? PAYMENT_STATUS[element.payment_status] : 'N/A',
                  paid_by: element.paid_by ? PAYMENT_MODE[element.paid_by] : 'N/A',
                  total_price: price ? formatNumberToCurrency(price) : 'N/A'
                });
              }
            });
          }
        });
        setAllTickets(tempArr);
        handlePrint();
      });
  }

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    removeAfterPrint: true,
    onAfterPrint: () => {
      setShowHiddleDataTable(false);
    }
  });

  const details = (row) => {
    const data = row?.data?.event_tickets;
    if (data && data.length) {
      return (
        <div className="expanded-table-container">
          <table className="expanded-table">
            <thead>
              <tr>
                <th>Ticket No</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                {
                  !props.scanTicket &&
                  <th>Action</th>
                }
              </tr>
            </thead>
            <tbody>
              {
                data.map((val, i) => (
                  <tr key={i} className={val.cancelation_requested ? 'cancel-request' : ''}>
                    <td> #{val.ticket_no} </td>
                    <td> {val.first_name} {val.last_name}</td>
                    <td>{val.email ? val.email : 'N/A'}</td>
                    <td>{val.phone ? val.phone : 'N/A'}</td>

                    {
                      !props.scanTicket &&
                      <td>
                        {
                          row?.data?.paid_by === 'card' && (val.status !== 'cancel') && <button className="btn mb-0" onClick={() => refundSingleTicket(row?.data, val)}>Cancel</button>
                        }

                        {
                          (row?.data?.paid_by !== 'card') && val.status !== 'cancel' && <button className="btn mb-0" onClick={() => cancel(row?.data, val)}>Cancel</button>
                        }

                        {
                          val.status === 'cancel' && <span className="cancelled-text">Cancelled</span>
                        }

                      </td>
                    }
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      );
    } else {
      return (
        <div className="expanded-table-container">
          <div className="expanded-table-empty">No tickets found.</div>
        </div>
      );
    }
  }

  const conditionalRowStyles = [{
    when: row => row.cancelation_requested,
    style: {
      backgroundColor: "#ffebeb",
    },
  }];

  const refundAmount = (row) => {
    setRefundPopup(true);
    let ticketPrice = +row.total_price;

    const remaingAmont = (+row.total_price - +row.refund_amount).toFixed(2);
    if (+ticketPrice > +remaingAmont) {
      ticketPrice = remaingAmont;
    }

    setRefundInfo({
      id: row.id,
      total: +ticketPrice
    });
  }

  const refundSingleTicket = (data, ticket) => {
    let ticketPrice = (data.total_price / data.event_tickets.length).toFixed(2);
    const remaingAmont = (+data.total_price - +data.refund_amount).toFixed(2);
    if (+ticketPrice > +remaingAmont) {
      ticketPrice = remaingAmont;
    }
    setRefundPopup(true);
    setRefundInfo({
      id: data.id,
      ticket_id: ticket.id,
      total: +ticketPrice
    });
  }

  const cancelAll = (row) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: messages.confirmCancel,
      icon: faExclamationTriangle,
      action: () => {
        axiosApi.post(`${config.apiUrl}/tickets/cancel`, {
          id: row.id
        })
          .then((response) => {
            setOpenWarningPopup(false);
            getTickets(props.eventId, queryparam);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }

  const cancel = (row, ticket) => {
    setOpenWarningPopup(true);
    setPopUpContent({
      header: 'Warning',
      description: messages.confirmCancel,
      icon: faExclamationTriangle,
      action: () => {
        axiosApi.post(`${config.apiUrl}/tickets/cancel`, {
          id: row.id,
          ticket_id: ticket.id,
        })
          .then((response) => {
            setOpenWarningPopup(false);
            getTickets(props.eventId, queryparam);
          })
          .catch((error) => {
            setOpenWarningPopup(false);
          });
      }
    });
  }

  const refund = (amount) => {
    setRefundPopup(false);
    refundInfo.total = amount;
    if (refundInfo.id) {
      axiosApi.post(`${config.apiUrl}/tickets/refund`, refundInfo)
        .then((res) => {
          setRefundInfo({});
          getTickets(props.eventId, queryparam);
        });
    }
  }

  const openInvoice = async (event) => {
    fetch(`${config.apiUrl}/events/get-ticket/${event?.id}`, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') ? localStorage.getItem('token') : ''}`,
        'content-type': 'application/json'
      },
    })
      .then(response => {
        if (response.status === 200) {
          response.blob().then((blb) => {
            const url = window.URL.createObjectURL(
              new Blob([blb]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              event.invoice_file ? event.invoice_file : `${event.id}-invoice.pdf`,
            );
            // Append to html link element page
            document.body.appendChild(link);
            // Start download
            link.click();
            // Clean up and remove the link
            link.parentNode.removeChild(link);
          })
        } else {
          response.json().then((res) => {
            console.log(res)
          })
        }
      })
  }

  return (
    <>
      <div className={''}></div>
      {!isAdd && <div className="user-wrapper">
        <div className="header-blk">
          <h2>Overview</h2>
        </div>
        <div className="cards-wrapper">
          <div className="cards-blk">
            <RateCard text='Total Tickets' value={overview.total || 0} />
            <RateCard text='Sold Tickets' value={overview.sold || 0} />
            <RateCard text='Left Tickets' value={overview.left || 0} />
            <RateCard text='Total Visited' value={overview.scanned || 0} />
          </div>
        </div>
        <div className="search-blk with-add-btn">
          <h2>Search</h2>
          <div className="lead-form-add-btn lead-form-rs">
            <form onSubmit={handleSearch}>
              <div className="input-field">
                <label htmlFor="first_name">First Name</label>
                <input type="text" id="first_name" name="first_name" onChange={handleChange} />
              </div>
              <div className="input-field">
                <label htmlFor="last_name">Last Name</label>
                <input type="text" id="last_name" name="last_name" onChange={handleChange} />
              </div>
              <div className="input-field">
                <label htmlFor="email">Email Address</label>
                <input type="text" id="email" name="email" onChange={handleChange} />
              </div>
              <div className="input-field">
                <label htmlFor="contact">Phone Number</label>
                <input id="cellPhone" name="cell_phone" onChange={handleChange} />
              </div>
              <button type='submit'>Search</button>
            </form>
            {+overview.left > 0 && !props.scanTicket && <div className="right">
                <button onClick={() => { props.isTicketInfo(true); setIsAdd(true) }} ><img src={add} alt="" />Add Ticket</button>
            </div>}
            <div className="right">
              <button className="print-rs" onClick={() => printAllData()} ><img src={print} alt="" /></button>
            </div>
            {
              showHiddleDataTable && allTickets.length > 0 && (
                <TicketPrint ref={printRef} eventDetail={props?.eventInfo} columns={printColumns} row={printRow} title='Tickets' data={allTickets} ticketOverview={overview} />
              )
            }
          </div>
        </div>
      </div>}
      {!isAdd && <div className="table-wrapper">
        <div className="heading-blk">
          <div className="left">
            <h2>Results</h2>
            <p>Select a event to view details.</p>
          </div>
        </div>
        <div id="printableTable" className="dataTable">
          <DataTableComponent key="table-admin-users"
            // loading={loader}
            type={'tickets'}
            showTicket={showTicket}
            data={tickets}
            columns={columns}
            onFilterChange={handleChange}
            totalPage={totalPage}
            expandableRows={true}
            expandableRowsComponent={details}
          // conditionalRowStyles={conditionalRowStyles}
          // limit={userDetail.limit}
          // refresh={() => getUsers()} 
          />
        </div>
      </div>}
      {
        isAdd && <AddTicket isRefresh={refreshList} isEdit={isEdit} leftTickets={overview?.left} id={props.eventId} backToTickets={showListing} />
      }
      {
        refundPopup && <RedundPopup total={refundInfo.total} close={() => setRefundPopup(false)} refund={(e) => refund(e)} max={refundInfo.total}></RedundPopup>
      }

      <WarningDialogue
        isOpen={openWarningPopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  );
}

export default withRouter(EventTicket);
